export default "__VITE_ASSET__I18BY7O6__"